import { styled, Box, Grid, MuiTableCell } from '../../../../base';

export const StyledHeader = styled(Grid)(({ theme }) => ({
    justifyContent: 'space-between',
    padding: theme.spacing(2),
    alignItems: 'center',
}));

export const StyledChartCard = styled(Grid)(({ theme }) => ({
    borderRadius: 16,
    border: `1px solid ${theme.palette.grey[300]}`,
}));

export const StyledChartHeader = styled(Box)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(2),
    gap: theme.spacing(2),
}));

export const StyledLegendItem = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
}));

export const StyledColorDot = styled('span')<{ dotColor: string }>(
    ({ dotColor }) => ({
        width: 12,
        height: 12,
        borderRadius: 7,
        backgroundColor: dotColor,
    })
);

export const StyledTableCard = styled(Grid)(({ theme }) => ({
    borderRadius: 16,
    boxShadow: theme.shadows[2],
    border: `1px solid ${theme.palette.grey[300]}`,
    overflow: 'hidden',
}));

export const StyledTableHeaderCell = styled(MuiTableCell)(({ theme }) => ({
    backgroundColor: theme.palette.grey[100],
    color: theme.palette.text.secondary,
}));

export const StyledTableBodyCell = styled(MuiTableCell)(({ theme }) => ({
    color: theme.palette.text.primary,
}));
